// Prospect-demo activity, browser side. trackDemo({ type, ... }) queues an event and sends it to /api/demo-guide/event a couple of
// seconds later, in batches; the server decides what is kept (src/lib/demoActivity.js). Never throws, never shows anything: if a send
// fails the events are simply lost. Only call this for prospect demo accounts (the server refuses everyone else).

import { fetchWithCsrf } from './fetchWithCsrf';

const FLUSH_AFTER_MS = 2000;
const MAX_BATCH = 20;
let queue = [];
let timer = null;

export function flushDemoTrack() {
  if (timer) { clearTimeout(timer); timer = null; }
  while (queue.length) {
    const events = queue.splice(0, MAX_BATCH);
    try {
      fetchWithCsrf('/api/demo-guide/event', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ events }),
        keepalive: true, // lets the last batch leave while the tab is closing
      }).catch(() => {});
    } catch { /* tracking must never break the page */ }
  }
}

export function trackDemo(event) {
  if (!event || !event.type) return;
  queue.push(event);
  if (queue.length >= MAX_BATCH) flushDemoTrack();
  else if (!timer) timer = setTimeout(flushDemoTrack, FLUSH_AFTER_MS);
}

if (typeof window !== 'undefined') {
  window.addEventListener('pagehide', flushDemoTrack);
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'hidden') flushDemoTrack(); });
}
